import styled from 'styled-components';
export const PdfViewerRoot = styled.div `
  width: ${({ $fitContainer }) => ($fitContainer ? '100%' : '60%')};
  height: 100%;
  margin-inline: auto;
`;
export const PdfViewerToolbar = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 10%;
  gap: ${({ theme }) => theme.spacing.sm}px;
  padding: ${({ theme }) => theme.spacing.xs}px;
  border: 1px solid ${({ theme }) => theme.colors.grey_1};
  background: ${({ theme }) => theme.colors.beige_1};
  box-sizing: border-box;
`;
export const PdfViewerDocument = styled.div `
  width: 100%;
  height: 90%;
  padding: ${({ theme }) => theme.spacing.md}px;
  border: 1px solid ${({ theme }) => theme.colors.grey_1};
  background-color: ${({ theme }) => theme.colors.grey_1};
  box-sizing: border-box;
`;
export const PdfViewerPages = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
`;
